import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { SessionService } from '@src/app/modules/auth';
import { EnvService } from '@src/app/modules/env';
import { reload } from '@src/utils';

@Component({
  selector: 'app-update-app-dialog',
  templateUrl: './update-app-dialog.component.html',
  styleUrls: ['./update-app-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateAppDialogComponent extends BaseResizableComponent {
  private readonly session = inject(SessionService);
  readonly env = inject(EnvService);

  appConfig = this.session.appConfig;

  reload() {
    reload();
  }
}
